module.exports = __webpack_public_path__ + "static/media/72.6704bf70.png";